import { types } from '../types/typesCompras';

const initialState = {
    expensesList: [],
    detail: {
        id: 0,
        numero: '000000',
        referencia: 'nueva compra',
        id_tipo_documento: null,
        id_forma_pago: null,
        id_moneda: null,
        simbolo: 'S/',
        separacion_miles: ',',
        separacion_decimales: '.',
        observaciones: null,
        estado: null,
        fecha_emision: null,
        id_proveedor: null,
        razon_social: null,
        validado: false,
        subtotal: 0,
        descuento: 0,
        monto_base: 0,
        impuesto_porcentaje: 0,
        impuesto_tipo_calculo: null,
        impuesto_nombre: null,
        total_impuesto: 0,
        total_compra: 0,
        id_ppto: null,
        pagado: false,
        items: [],
        pagos: [],
        facturas: []
    }
}

export const comprasReducer = (state = initialState, action) => {

    switch (action.type) {

        case types.comprasLoadList:
            return {
                ...state,
                expensesList: action.payload
            }

        case types.comprasLoadDetail:
            return {
                ...state,
                detail: action.payload
            }

        case types.comprasAddItem:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    items: [...state.detail.items, action.payload]
                }
            }

        case types.comprasLoadItems:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    items: action.payload
                }
            }

        case types.comprasUpdateTotales:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    subtotal: action.payload.subtotal,
                    descuento: action.payload.descuento,
                    monto_base: action.payload.monto_base,
                    total_impuesto: action.payload.total_impuesto,
                    total_compra: action.payload.total_compra,
                }
            }

        case types.comprasUpdateSetForm:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    referencia: action.payload.referencia,
                    fecha_emision: action.payload.fecha_emision,
                    id_moneda: action.payload.id_moneda,
                    id_proveedor: action.payload.id_proveedor,
                    id_tipo_documento: action.payload.id_tipo_documento,
                    id_forma_pago: action.payload.id_forma_pago,
                    observaciones: action.payload.observaciones,
                }
            }

        case types.comprasUpdateInfoDoc:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    impuesto_nombre: action.payload.impuesto_nombre,
                    impuesto_porcentaje: action.payload.impuesto_porcentaje,
                    impuesto_tipo_calculo: action.payload.impuesto_tipo_calculo,
                    total_impuesto: action.payload.total_impuesto,
                    total_compra: action.payload.total_compra,
                }
            }

        case types.comprasSetNewIds:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    id: action.payload.id,
                    numero: action.payload.numero
                }
            }

        case types.comprasAddPagos:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    pagos: [...state.detail.pagos, action.payload]
                }
            }

        default:
            return state;
    }

}
